import AddItemForm from "../../../../components/AddFormItem";


const SystemTypesAdd = () => {
    return (
        <div>
            <h2>Add</h2>
            <AddItemForm endpoint={"system_types"}/>
        </div>
    );
};

export default SystemTypesAdd